import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "4", height: "16", viewBox: "0 0 4 16" }, this.props),
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.315 6.5A1.75 1.75 0 1 1 .5 8.25 1.783 1.783 0 0 1 2.315 6.5zm0 6a1.75 1.75 0 1 1-1.814 1.75 1.783 1.783 0 0 1 1.815-1.75zM.502 2.207A1.75 1.75 0 0 1 4 2.25 1.787 1.787 0 0 1 2.185 4 1.75 1.75 0 0 1 .5 2.207z" }));
    };
    return SVG;
}(React.Component));
export default SVG;
